<template>
  <div class="custom-field">
    <div v-if="fieldType === 'number' || fieldType === 'text'">
      <generic-html
        v-if="fieldDescription"
        :component="{ html: fieldDescription }"
        class="description"
      />
      <generic-input
        :component="fieldComponent"
        :value="fieldValue"
        :max-length="maxLength"
        @input="emitValue"
      />
    </div>
    <generic-switch
      v-if="fieldType === 'bool'"
      :component="fieldComponent"
      :value="fieldValue"
      @input="emitValue"
    />
    <div v-if="fieldType === 'select' || fieldType === 'interests'">
      <generic-html
        v-if="fieldDescription"
        :component="{ html: fieldDescription }"
        class="description"
      />
      <generic-select
        :options="fieldChoices"
        :component="fieldComponent"
        :multiple="fieldType === 'interests'"
        :value="fieldValue"
        @input="emitValue"
      />
    </div>
    <div v-if="fieldType === 'location'">
      <generic-html
        v-if="fieldDescription"
        :component="{ html: fieldDescription }"
        class="description"
      />
      <generic-location
        :component="fieldComponent"
        :value="fieldValue"
        @input="emitValue"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {getFieldCustomRegexValidation} from "@/utils/auth/validation";
import GenericInput from "@/components/generic/GenericInput";
import GenericHtml from "@/components/generic/GenericHtml";
import GenericSwitch from "@/components/generic/GenericSwitch";
import GenericSelect from "@/components/generic/GenericSelect";
import GenericLocation from "@/components/generic/GenericLocation";

export default {
  components: {
    GenericInput,
    GenericHtml,
    GenericSwitch,
    GenericSelect,
    GenericLocation
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    fieldValue: {
      type: [String, Boolean, Array, Object, Number],
      default: ""
    }
  },
  computed: {
    fieldKey() {
      return _.get(this.field, "key");
    },
    fieldType() {
      return _.get(this.field, "type");
    },
    fieldLabel() {
      return _.get(this.field, "props.label") || _.get(this.field, "name", "");
    },
    fieldDescription() {
      return _.get(this.field, "metadata.description", "");
    },
    fieldChoices() {
      const choices = _.get(this.field, "metadata.choices", []);

      if (!_.isEmpty(choices)) {
        return choices.map((choice) => {
          return {
            text: _.get(choice, "title", ""),
            value: _.get(choice, "value", "")
          };
        });
      }

      return choices;
    },
    fieldComponent() {
      return {
        name: this.fieldKey,
        label: this.fieldLabel,
        placeholder: this.fieldLabel,
        description: this.fieldDescription,
        required: _.get(this.field, "required", false),
        regexValidation: getFieldCustomRegexValidation(this.field.validators)
      };
    },
    maxLength() {
      return _.get(this.field, "metadata.max_length");
    }
  },
  methods: {
    emitValue(newValue) {
      const payload = {
        key: this.fieldKey,
        value: newValue
      };

      this.$emit("input", payload);
    }
  }
};
</script>

<style lang="scss" scoped></style>
